module.exports = __webpack_public_path__ + "img/vacance5.21a68c93.jpg";